"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketing = void 0;
exports.marketing = function (axios) {
    return {
        postMarketingProductSetting: function (request) {
            return axios.post('/marketing/products/settings', request.data);
        },
        postMarketingProductSettingV2: function (request) {
            return axios.post('/marketing/products/settings', request.data);
        },
        getConfigurationsCampaignsBillingSetupsExists: function (request) {
            return axios.get("/configurations/campaigns/billing-setups/exists?mallNo=" + request.params.mallNo);
        },
        getConfigurationsCampaigns: function (request) {
            return axios.get("/configurations/campaigns?mallNo=" + request.params.mallNo);
        },
        putConfigurationsCampaignsStatus: function (request) {
            return axios.put('/configurations/campaigns/status', request.data);
        },
        getConfigurationsCampaignsRequirements: function (request) {
            return axios.get("/configurations/campaigns/requirements?mallNo=" + request.params.mallNo);
        },
        postConfigurationsCampaigns: function (request) {
            return axios.post('/configurations/campaigns', request.data);
        },
        putConfigurationsCampaigns: function (request) {
            return axios.put('/configurations/campaigns', request.data);
        },
        getConfigurationsCampaignsCampaignNo: function (request) {
            return axios.get("/configurations/campaigns/" + request.pathParams.campaignNo + "?mallNo=" + request.params.mallNo);
        }
    };
};
